/* eslint-disable no-unreachable */
/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

export default function SVGComponent(props) {
  switch (props.iconName) {
    case 'Icon-invoice':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.895"
          height="17.5"
          viewBox="0 0 9.895 17.5"
          className="svg-fill"
        >
          <defs>
            <style />
          </defs>
          <path
            className="a"
            d="M19.852,13.776A3.553,3.553,0,0,1,18.8,16.349a4.686,4.686,0,0,1-2.741,1.333v1.709a.292.292,0,0,1-.1.225.346.346,0,0,1-.244.088H14.284a.34.34,0,0,1-.239-.093.289.289,0,0,1-.1-.22V17.682a7.164,7.164,0,0,1-1.352-.3,7.444,7.444,0,0,1-1.076-.435,7.238,7.238,0,0,1-.785-.469,5.977,5.977,0,0,1-.493-.366q-.133-.117-.186-.176a.28.28,0,0,1-.021-.4l1.092-1.318a.339.339,0,0,1,.244-.117.275.275,0,0,1,.255.088l.021.02a5.722,5.722,0,0,0,2.577,1.221,4.01,4.01,0,0,0,.785.078,2.73,2.73,0,0,0,1.511-.42,1.337,1.337,0,0,0,.652-1.191.932.932,0,0,0-.159-.518,1.865,1.865,0,0,0-.355-.41,2.948,2.948,0,0,0-.62-.366q-.424-.2-.7-.313t-.848-.317l-.652-.244q-.239-.088-.652-.259t-.663-.3q-.249-.132-.6-.347a3.7,3.7,0,0,1-.567-.415,6.284,6.284,0,0,1-.461-.479,2.363,2.363,0,0,1-.376-.566,3.7,3.7,0,0,1-.223-.649,3.133,3.133,0,0,1-.09-.762,3.206,3.206,0,0,1,1.039-2.363,5,5,0,0,1,2.7-1.309V2.516a.289.289,0,0,1,.1-.22.341.341,0,0,1,.239-.093h1.432a.346.346,0,0,1,.244.088.292.292,0,0,1,.1.225V4.235a6.343,6.343,0,0,1,1.172.225,7.158,7.158,0,0,1,.923.327,5.224,5.224,0,0,1,.673.366q.318.205.414.283t.159.137a.267.267,0,0,1,.053.371L18.59,7.369a.29.29,0,0,1-.244.156.359.359,0,0,1-.286-.068q-.032-.029-.154-.117t-.414-.259a5.633,5.633,0,0,0-.62-.313,5.014,5.014,0,0,0-.79-.254,3.824,3.824,0,0,0-.907-.112,2.932,2.932,0,0,0-1.644.42A1.257,1.257,0,0,0,12.9,7.907a1.2,1.2,0,0,0,.09.469,1.1,1.1,0,0,0,.313.405,4.608,4.608,0,0,0,.419.322,3.837,3.837,0,0,0,.594.3q.4.171.642.264t.742.269q.562.2.859.308t.806.342a6.575,6.575,0,0,1,.8.415,6.7,6.7,0,0,1,.658.488,2.588,2.588,0,0,1,.562.62,3.389,3.389,0,0,1,.334.747,2.985,2.985,0,0,1,.138.918Z"
            transform="translate(-9.957 -2.203)"
          />
        </svg>
      );
      break;
    case 'Icon-CMS':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.5"
          height="17.5"
          viewBox="0 0 17.5 17.5"
          className="svg-fill"
        >
          <path
            className="a"
            d="M6.75,11.125h4.375V6.75H6.75ZM13.313,24.25h4.375V19.875H13.313Zm-6.562,0h4.375V19.875H6.75Zm0-6.562h4.375V13.313H6.75Zm6.563,0h4.375V13.313H13.313ZM19.875,6.75v4.375H24.25V6.75Zm-6.562,4.375h4.375V6.75H13.313Zm6.563,6.563H24.25V13.313H19.875Zm0,6.563H24.25V19.875H19.875Z"
            transform="translate(-6.75 -6.75)"
          />
        </svg>
      );
      break;
    case 'Icon-tasks':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.742"
          height="17.5"
          viewBox="0 0 20.742 17.5"
          className="svg-fill"
        >
          <defs>
            <style />
          </defs>
          <path
            className="a"
            d="M5.656,2.391a.486.486,0,0,0-.689,0L2.387,4.955l-.92-.9a.486.486,0,0,0-.689,0L.143,4.7a.486.486,0,0,0,0,.689L2.071,7.3a.518.518,0,0,0,.713,0l.632-.633L6.341,3.748a.49.49,0,0,0,0-.689Zm0,6.448a.486.486,0,0,0-.689,0L2.387,11.42l-.92-.9a.486.486,0,0,0-.689,0l-.636.636a.486.486,0,0,0,0,.689l1.923,1.924a.517.517,0,0,0,.713,0l.636-.636L6.34,10.212a.486.486,0,0,0,0-.685Zm-3.063,7.02a1.944,1.944,0,1,0,0,3.889,1.944,1.944,0,1,0,0-3.889Zm17.5.648H8.427a.648.648,0,0,0-.648.648v1.3a.648.648,0,0,0,.648.648H20.094a.648.648,0,0,0,.648-.648v-1.3A.648.648,0,0,0,20.094,16.507Zm0-12.962H8.427a.648.648,0,0,0-.648.648v1.3a.648.648,0,0,0,.648.648H20.094a.648.648,0,0,0,.648-.648v-1.3A.648.648,0,0,0,20.094,3.545Zm0,6.481H8.427a.648.648,0,0,0-.648.648v1.3a.648.648,0,0,0,.648.648H20.094a.648.648,0,0,0,.648-.648v-1.3A.648.648,0,0,0,20.094,10.026Z"
            transform="translate(0 -2.248)"
          />
        </svg>
      );
      break;
    case 'Icon-maintain':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.52"
          height="18.074"
          viewBox="0 0 21.52 18.074"
          className="svg-fill-maintain"
        >
          <defs>
            <style />
          </defs>
          <g transform="translate(-60.48 -317.897)">
            <g transform="translate(59.98 314.5)">
              <path
                className="a"
                d="M15.5,27.75V26A3.5,3.5,0,0,0,12,22.5H5A3.5,3.5,0,0,0,1.5,26v1.75"
                transform="translate(0 -7.279)"
              />
              <path
                className="a"
                d="M14.5,8A3.5,3.5,0,1,1,11,4.5,3.5,3.5,0,0,1,14.5,8Z"
                transform="translate(-2.423)"
              />
              <path
                className="a"
                d="M32.625,27.831v-1.75A3.5,3.5,0,0,0,30,22.7"
                transform="translate(-11.605 -7.36)"
              />
              <path
                className="a"
                d="M24,4.7a3.5,3.5,0,0,1,0,6.781"
                transform="translate(-9.162 -0.081)"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case 'Icon-display':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="17.5"
          viewBox="0 0 20 17.5"
          className="svg-fill"
        >
          <defs>
            <style />
          </defs>
          <path
            className="a"
            d="M2.571,3.856v12.5h20V3.856h-20Zm18.75,11.25H3.821v-10h17.5Zm-5.625,2.5H9.446l-.625,2.5-1.25,1.25h10l-1.25-1.25Z"
            transform="translate(-2.571 -3.856)"
          />
        </svg>
      );
      break;
    case 'Icon-research':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.42"
          height="17.503"
          viewBox="0 0 20.42 17.503"
          className="svg-fill"
        >
          <defs>
            <style />
          </defs>
          <g transform="translate(-2.25 -4.5)">
            <path
              className="a"
              d="M21.941,4.5H9.543a.751.751,0,0,0-.729.752V6.688H4.164A1.92,1.92,0,0,0,2.25,8.6V18.06A3.951,3.951,0,0,0,6.17,22H18.919a3.76,3.76,0,0,0,3.751-3.738V5.229A.731.731,0,0,0,21.941,4.5ZM8.814,8.146V16.9H6.9V9.022a2.226,2.226,0,0,0-.15-.875ZM8.039,19.788a2.692,2.692,0,0,1-1.846.757A2.49,2.49,0,0,1,3.709,18.06V9.022a.866.866,0,1,1,1.732,0v8.606a.731.731,0,0,0,.729.729H8.791A2.4,2.4,0,0,1,8.039,19.788Zm13.173-1.522a2.3,2.3,0,0,1-2.293,2.279H9.329a3.81,3.81,0,0,0,.944-2.484V6H21.211Z"
            />
            <path
              className="a"
              d="M17.438,9.563h7.25V12.1h-7.25Z"
              transform="translate(-5.31 -1.777)"
            />
            <path
              className="a"
              d="M17.438,15.75h7.25V17.2h-7.25Z"
              transform="translate(-5.31 -3.953)"
            />
            <path
              className="a"
              d="M17.438,20.25h7.25V21.7h-7.25Z"
              transform="translate(-5.31 -5.535)"
            />
            <path
              className="a"
              d="M24.487,24.75h-7.25s0,1.45-.362,1.45h6.738C24.487,26.2,24.487,25.248,24.487,24.75Z"
              transform="translate(-5.111 -7.116)"
            />
          </g>
        </svg>
      );
      break;

    case 'Icon-chart-bars':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.542"
          height="17.5"
          viewBox="0 0 21.542 17.5"
          className="svg-fill"
        >
          <defs>
            <style />
          </defs>
          <path
            className="a"
            d="M2.571,20.592H24.113v2.692H2.571Zm2.693-5.385H7.956v4.038H5.263ZM9.3,9.823H12v9.423H9.3Zm4.039,4.038h2.693v5.385H13.342Zm4.039-8.077h2.693V19.246H17.381Z"
            transform="translate(-2.571 -5.784)"
          />
        </svg>
      );
      break;
    case 'Icon-system':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.385"
          height="17.5"
          viewBox="0 0 21.385 17.5"
          className="svg-fill"
        >
          <defs />
          <path
            className="a"
            d="M9.276,17.139h6.318a2.431,2.431,0,0,0,0-4.861h-.049a3.385,3.385,0,0,0-6.425-.953H8.965a2.915,2.915,0,0,0,.311,5.814ZM20.941,4.5H3.444A1.95,1.95,0,0,0,1.5,6.444V20.056A1.95,1.95,0,0,0,3.444,22h17.5a1.95,1.95,0,0,0,1.944-1.944V6.444A1.95,1.95,0,0,0,20.941,4.5Zm0,15.565H3.444V6.435h17.5V20.065Z"
            transform="translate(-1.5 -4.5)"
          />
        </svg>
      );
      break;
    case 'Icon-list':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.385"
          height="17.5"
          viewBox="0 0 21.385 17.5"
          className="svg-fill"
        >
          <defs />
          <path
            className="a"
            d="M9.276,17.139h6.318a2.431,2.431,0,0,0,0-4.861h-.049a3.385,3.385,0,0,0-6.425-.953H8.965a2.915,2.915,0,0,0,.311,5.814ZM20.941,4.5H3.444A1.95,1.95,0,0,0,1.5,6.444V20.056A1.95,1.95,0,0,0,3.444,22h17.5a1.95,1.95,0,0,0,1.944-1.944V6.444A1.95,1.95,0,0,0,20.941,4.5Zm0,15.565H3.444V6.435h17.5V20.065Z"
            transform="translate(-1.5 -4.5)"
          />
        </svg>
      );
      break;
    case 'Icon-printer':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          className="svg-fill-printer"
        >
          <defs>
            <style />
          </defs>
          <g transform="translate(-1054 -20)">
            <circle
              className="a"
              cx="16.5"
              cy="16.5"
              r="16.5"
              transform="translate(1054 20)"
            />
            <path
              className="b"
              d="M8.857,3.856H21.428V7H8.857V3.856ZM26.143,8.57h-22a1.576,1.576,0,0,0-1.571,1.571V18a1.576,1.576,0,0,0,1.571,1.571H8.857v6.286H21.428V19.571h4.714A1.576,1.576,0,0,0,27.714,18V10.142A1.576,1.576,0,0,0,26.143,8.57ZM5.714,13.285a1.571,1.571,0,1,1,1.571-1.571,1.571,1.571,0,0,1-1.571,1.571Zm14.143,11H10.428V16.428h9.429Z"
              transform="translate(1055.429 21.144)"
            />
          </g>
        </svg>
      );
    case 'Icon-print':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          class="bi bi-printer"
          viewBox="0 0 16 16"
        >
          <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
          <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
        </svg>
      );
      break;
    case 'Icon-printer-disabled':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          fill="#fff"
        >
          <defs>
            <style />
          </defs>
          <g transform="translate(-1054 -20)">
            <circle
              className="a"
              cx="16.5"
              cy="16.5"
              r="16.5"
              transform="translate(1054 20)"
            />
            <path
              className="b"
              d="M8.857,3.856H21.428V7H8.857V3.856ZM26.143,8.57h-22a1.576,1.576,0,0,0-1.571,1.571V18a1.576,1.576,0,0,0,1.571,1.571H8.857v6.286H21.428V19.571h4.714A1.576,1.576,0,0,0,27.714,18V10.142A1.576,1.576,0,0,0,26.143,8.57ZM5.714,13.285a1.571,1.571,0,1,1,1.571-1.571,1.571,1.571,0,0,1-1.571,1.571Zm14.143,11H10.428V16.428h9.429Z"
              transform="translate(1055.429 21.144)"
              fill="#d4d4d4"
            />
          </g>
        </svg>
      );
      break;
    case 'Icon-export':
      return (
        <svg
          id="Icon-Component-Export"
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 33 33"
        >
          <g id="Icon-Export" transform="translate(11.75 8.75)">
            <path
              id="Icon_Document"
              d="M10.759,3.631a.736.736,0,0,0-.2-.5L7.82.208A.652.652,0,0,0,7.343,0H7.172V3.813h3.586Zm0,6.854Zm0-6.062c-.37,0-4.483.265-4.483-.128V0H.672A.693.693,0,0,0,0,.715v13.82a.693.693,0,0,0,.672.715h9.414a.693.693,0,0,0,.672-.715V4.422Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#274463"
              strokeWidth="1"
            />
            <path
              id="Icon_Arrow-Right"
              d="M5.026,7.165l.274.274a.3.3,0,0,1,0,.418l-2.4,2.4a.3.3,0,0,1-.418,0l-2.4-2.4a.3.3,0,0,1,0-.418l.274-.274a.3.3,0,0,1,.423,0L2.2,8.656V.3A.3.3,0,0,1,2.5,0h.395a.3.3,0,0,1,.3.3v8.36L4.6,7.17a.294.294,0,0,1,.423,0Z"
              transform="translate(4.908 12.361) rotate(-90)"
              fill="#274463"
            />
          </g>
        </svg>
      );
      break;
    case 'Icon-export-2rem':
      return (
        <svg
          id="Icon-Component-Export-2rem"
          xmlns="http://www.w3.org/2000/svg"
          width="34"
          height="34"
          viewBox="0 0 33 33"
        >
          <g id="Icon-Export" transform="translate(11.75 8.75)">
            <path
              id="Icon_Document"
              d="M10.759,3.631a.736.736,0,0,0-.2-.5L7.82.208A.652.652,0,0,0,7.343,0H7.172V3.813h3.586Zm0,6.854Zm0-6.062c-.37,0-4.483.265-4.483-.128V0H.672A.693.693,0,0,0,0,.715v13.82a.693.693,0,0,0,.672.715h9.414a.693.693,0,0,0,.672-.715V4.422Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#274463"
              strokeWidth="1"
            />
            <path
              id="Icon_Arrow-Right"
              d="M5.026,7.165l.274.274a.3.3,0,0,1,0,.418l-2.4,2.4a.3.3,0,0,1-.418,0l-2.4-2.4a.3.3,0,0,1,0-.418l.274-.274a.3.3,0,0,1,.423,0L2.2,8.656V.3A.3.3,0,0,1,2.5,0h.395a.3.3,0,0,1,.3.3v8.36L4.6,7.17a.294.294,0,0,1,.423,0Z"
              transform="translate(4.908 12.361) rotate(-90)"
              fill="#274463"
            />
          </g>
        </svg>
      );
      break;
    case 'Icon-export1':
      return (
        <svg
          id="Icon-Component-Export"
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
        >
          <g id="Icon-Export1" transform="translate(11.75 8.75)">
            <path
              id="Icon_Document1"
              d="M10.759,3.631a.736.736,0,0,0-.2-.5L7.82.208A.652.652,0,0,0,7.343,0H7.172V3.813h3.586Zm0,6.854Zm0-6.062c-.37,0-4.483.265-4.483-.128V0H.672A.693.693,0,0,0,0,.715v13.82a.693.693,0,0,0,.672.715h9.414a.693.693,0,0,0,.672-.715V4.422Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#274463"
              strokeWidth="1"
            />
            <path
              id="Icon_Arrow-Right1"
              d="M5.026,7.165l.274.274a.3.3,0,0,1,0,.418l-2.4,2.4a.3.3,0,0,1-.418,0l-2.4-2.4a.3.3,0,0,1,0-.418l.274-.274a.3.3,0,0,1,.423,0L2.2,8.656V.3A.3.3,0,0,1,2.5,0h.395a.3.3,0,0,1,.3.3v8.36L4.6,7.17a.294.294,0,0,1,.423,0Z"
              transform="translate(4.908 12.361) rotate(-90)"
              fill="#274463"
            />
          </g>
        </svg>
      );
      break;

    case 'Icon-accept':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="15"
          viewBox="0 0 20 20"
        >
          <path
            id="Icon_awesome-check-circle"
            data-name="Icon awesome-check-circle"
            d="M20.563,10.563a10,10,0,1,1-10-10A10,10,0,0,1,20.563,10.563ZM9.406,15.857l7.419-7.419a.645.645,0,0,0,0-.912l-.912-.912a.645.645,0,0,0-.912,0L8.95,12.664,6.125,9.839a.645.645,0,0,0-.912,0l-.912.912a.645.645,0,0,0,0,.912l4.194,4.194a.645.645,0,0,0,.912,0Z"
            transform="translate(-0.563 -0.563)"
            fill="#fff"
          />
        </svg>
      );
      break;

    case 'Icon-export-cell':
      return (
        <svg
          id="Icon-Component-Export"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 33 33"
        >
          <g id="Icon-Export" transform="translate(11.75 8.75)">
            <path
              id="Icon_Document"
              d="M10.759,3.631a.736.736,0,0,0-.2-.5L7.82.208A.652.652,0,0,0,7.343,0H7.172V3.813h3.586Zm0,6.854Zm0-6.062c-.37,0-4.483.265-4.483-.128V0H.672A.693.693,0,0,0,0,.715v13.82a.693.693,0,0,0,.672.715h9.414a.693.693,0,0,0,.672-.715V4.422Z"
              transform="translate(0 0)"
              fill="none"
              stroke="#274463"
              strokeWidth="1"
            />
            <path
              id="Icon_Arrow-Right"
              d="M5.026,7.165l.274.274a.3.3,0,0,1,0,.418l-2.4,2.4a.3.3,0,0,1-.418,0l-2.4-2.4a.3.3,0,0,1,0-.418l.274-.274a.3.3,0,0,1,.423,0L2.2,8.656V.3A.3.3,0,0,1,2.5,0h.395a.3.3,0,0,1,.3.3v8.36L4.6,7.17a.294.294,0,0,1,.423,0Z"
              transform="translate(4.908 12.361) rotate(-90)"
              fill="#274463"
            />
          </g>
        </svg>
      );
      break;
    case 'Icon-help':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="33"
          viewBox="0 0 33 33"
          className="svg-fill-help"
        >
          <defs>
            <style />
          </defs>
          <g transform="translate(-1107 -20)">
            <circle
              className="a"
              cx="16.5"
              cy="16.5"
              r="16.5"
              transform="translate(1107 20)"
            />
            <g transform="translate(-7 -1)">
              <path
                className="b"
                d="M15.875,5.058a10.813,10.813,0,1,1-7.65,3.167,10.746,10.746,0,0,1,7.65-3.167m0-1.683a12.5,12.5,0,1,0,12.5,12.5,12.5,12.5,0,0,0-12.5-12.5Z"
                transform="translate(1114.625 21.625)"
              />
              <path
                className="b"
                d="M17.493,11.25c2.314,0,3.907,1.313,3.907,3.2a3.1,3.1,0,0,1-1.734,2.8c-1.074.638-1.438,1.1-1.438,1.913v.5H16.086l-.019-.543a2.642,2.642,0,0,1,1.457-2.778c1.043-.638,1.481-1.042,1.481-1.824a1.508,1.508,0,0,0-1.66-1.357,1.576,1.576,0,0,0-1.654,1.553H13.5C13.543,12.683,15.012,11.25,17.493,11.25ZM15.87,22.07a1.324,1.324,0,1,1,1.321,1.3A1.306,1.306,0,0,1,15.87,22.07Z"
                transform="translate(1113.5 19.75)"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case 'Icon-checkbox-Checked':
      return (
        <svg
          id="Checkbox-selected"
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <rect
            id="Rectangle_2336"
            data-name="Rectangle 2336"
            width="20"
            height="20"
            rx="6"
            fill="#0047ba"
          />
          <path
            id="Path_18"
            data-name="Path 18"
            d="M4.4,7.3,0,2.908l1.42-1.42L4.4,4.4,8.792,0l1.42,1.42Z"
            transform="translate(4.734 6.763)"
            fill="#fff"
          />
        </svg>
      );
    case 'Export-icon':
      return (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
        >
          <svg
            id="Icon-Component-Export"
            xmlns="http://www.w3.org/2000/svg"
            width="33"
            height="33"
            viewBox="0 0 33 33"
          >
            <circle
              id="Ellipse_61"
              data-name="Ellipse 61"
              cx="16.5"
              cy="16.5"
              r="16.5"
              fill="#fff"
            />
            <g id="Icon-Export" transform="translate(11.75 8.75)">
              <path
                id="Icon_Document"
                d="M10.759,3.631a.736.736,0,0,0-.2-.5L7.82.208A.652.652,0,0,0,7.343,0H7.172V3.813h3.586Zm0,6.854Zm0-6.062c-.37,0-4.483.265-4.483-.128V0H.672A.693.693,0,0,0,0,.715v13.82a.693.693,0,0,0,.672.715h9.414a.693.693,0,0,0,.672-.715V4.422Z"
                transform="translate(0 0)"
                fill="none"
                stroke="#274463"
                strokeWidth="1"
              />
              <path
                id="Icon_Arrow-Right"
                d="M5.026,7.165l.274.274a.3.3,0,0,1,0,.418l-2.4,2.4a.3.3,0,0,1-.418,0l-2.4-2.4a.3.3,0,0,1,0-.418l.274-.274a.3.3,0,0,1,.423,0L2.2,8.656V.3A.3.3,0,0,1,2.5,0h.395a.3.3,0,0,1,.3.3v8.36L4.6,7.17a.294.294,0,0,1,.423,0Z"
                transform="translate(4.908 12.361) rotate(-90)"
                fill="#274463"
              />
            </g>
          </svg>
        </OverlayTrigger>
      );
    case 'Create-new-icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.071"
          height="18.071"
          viewBox="0 0 18.071 18.071"
        >
          <g
            id="Icon_feather-settings"
            data-name="Icon feather-settings"
            transform="translate(-0.9 -0.9)"
          >
            <path
              id="Path_477"
              data-name="Path 477"
              d="M18.1,15.8a2.3,2.3,0,1,1-2.3-2.3A2.3,2.3,0,0,1,18.1,15.8Z"
              transform="translate(-5.865 -5.865)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
            <path
              id="Path_478"
              data-name="Path 478"
              d="M15.61,12.236a1.265,1.265,0,0,0,.253,1.4l.046.046a1.535,1.535,0,1,1-2.17,2.17l-.046-.046a1.276,1.276,0,0,0-2.163.9v.13a1.534,1.534,0,0,1-3.067,0v-.069a1.265,1.265,0,0,0-.828-1.158,1.265,1.265,0,0,0-1.4.253l-.046.046a1.535,1.535,0,1,1-2.17-2.17l.046-.046a1.276,1.276,0,0,0-.9-2.163h-.13a1.534,1.534,0,0,1,0-3.067H3.1a1.265,1.265,0,0,0,1.158-.828,1.265,1.265,0,0,0-.253-1.4l-.046-.046a1.535,1.535,0,1,1,2.17-2.17l.046.046a1.265,1.265,0,0,0,1.4.253h.061A1.265,1.265,0,0,0,8.4,3.164v-.13a1.534,1.534,0,0,1,3.067,0V3.1a1.276,1.276,0,0,0,2.163.9l.046-.046a1.535,1.535,0,1,1,2.17,2.17l-.046.046a1.265,1.265,0,0,0-.253,1.4v.061a1.265,1.265,0,0,0,1.158.767h.13a1.534,1.534,0,0,1,0,3.067h-.069a1.265,1.265,0,0,0-1.158.767Z"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.2"
            />
          </g>
        </svg>
      );
    case 'Icon-cancel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.167"
          height="15.167"
          viewBox="0 0 15.167 15.167"
        >
          <path
            id="Icon-cancel"
            d="M10.583,3a7.583,7.583,0,1,0,7.583,7.583A7.576,7.576,0,0,0,10.583,3Zm3.792,10.306-1.069,1.069-2.722-2.722L7.861,14.375,6.792,13.306l2.722-2.722L6.792,7.861,7.861,6.792l2.722,2.722,2.722-2.722,1.069,1.069-2.722,2.722Z"
            transform="translate(-3 -3)"
            fill="#f4f4f4"
          />
        </svg>
      );
    case 'Icon-cancel-alert':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.167"
          height="15.167"
          viewBox="0 0 15.167 15.167"
        >
          <path
            id="Icon-cancel"
            d="M10.583,3a7.583,7.583,0,1,0,7.583,7.583A7.576,7.576,0,0,0,10.583,3Zm3.792,10.306-1.069,1.069-2.722-2.722L7.861,14.375,6.792,13.306l2.722-2.722L6.792,7.861,7.861,6.792l2.722,2.722,2.722-2.722,1.069,1.069-2.722,2.722Z"
            transform="translate(-3 -3)"
            fill="#274462"
          />
        </svg>
      );
    case 'Icon-cancel-drugtab':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15.167"
          height="15.167"
          viewBox="0 0 15.167 15.167"
        >
          <path
            id="Icon-cancel"
            d="M10.583,3a7.583,7.583,0,1,0,7.583,7.583A7.576,7.576,0,0,0,10.583,3Zm3.792,10.306-1.069,1.069-2.722-2.722L7.861,14.375,6.792,13.306l2.722-2.722L6.792,7.861,7.861,6.792l2.722,2.722,2.722-2.722,1.069,1.069-2.722,2.722Z"
            transform="translate(-3 -3)"
            fill="#274463"
          />
        </svg>
      );
    case 'Icon-info':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
        >
          <path
            id="Icon-info"
            d="M13,3A10,10,0,1,0,23,13,10,10,0,0,0,13,3Zm1,15H12V12h2Zm0-8H12V8h2Z"
            transform="translate(-3 -3)"
            fill="#5797ff"
          />
        </svg>
      );
    case 'Icon-awesome-save':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="13.71"
          viewBox="0 0 18 18"
        >
          <path
            id="Icon_awesome-save"
            data-name="Icon awesome-save"
            d="M17.435,6.185l-3.37-3.37A1.929,1.929,0,0,0,12.7,2.25H1.929A1.929,1.929,0,0,0,0,4.179V18.321A1.929,1.929,0,0,0,1.929,20.25H16.071A1.929,1.929,0,0,0,18,18.321V7.549a1.929,1.929,0,0,0-.565-1.364ZM9,17.679a2.571,2.571,0,1,1,2.571-2.571A2.571,2.571,0,0,1,9,17.679ZM12.857,5.443V9.482a.482.482,0,0,1-.482.482H3.054a.482.482,0,0,1-.482-.482V5.3a.482.482,0,0,1,.482-.482h9.182a.482.482,0,0,1,.341.141l.14.14a.482.482,0,0,1,.141.341Z"
            transform="translate(0 -2.25)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-run-now':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <g
            id="Icon-checkmark-circle-outline"
            transform="translate(-3.375 -3.375)"
          >
            <path
              id="Path_483"
              data-name="Path 483"
              d="M19.7,13.041l-.762-.783a.164.164,0,0,0-.121-.052h0a.157.157,0,0,0-.121.052L13.42,17.576,11.5,15.655a.167.167,0,0,0-.242,0l-.77.77a.172.172,0,0,0,0,.247l2.423,2.423a.766.766,0,0,0,.506.247.8.8,0,0,0,.5-.238h0l5.785-5.815A.185.185,0,0,0,19.7,13.041Z"
              transform="translate(-2.715 -3.397)"
              fill="#fff"
            />
            <path
              id="Path_484"
              data-name="Path 484"
              d="M12.375,4.587a7.785,7.785,0,1,1-5.508,2.28,7.737,7.737,0,0,1,5.508-2.28m0-1.212a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case 'Icon-run-later':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.713"
          height="18.713"
          viewBox="0 0 18.713 18.713"
        >
          <path
            id="Icon_material-timelapse"
            data-name="Icon material-timelapse"
            d="M16.324,8.389a5.59,5.59,0,0,0-3.967-1.647v5.614L8.389,16.324a5.61,5.61,0,1,0,7.934-7.934ZM12.357,3a9.357,9.357,0,1,0,9.357,9.357A9.36,9.36,0,0,0,12.357,3Zm0,16.842a7.485,7.485,0,1,1,7.485-7.485A7.483,7.483,0,0,1,12.357,19.842Z"
            transform="translate(-3 -3)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-view-history':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="13.71"
          viewBox="0 0 16 13.71"
        >
          <path
            id="Icon-history"
            d="M10.643,4.5a6.857,6.857,0,0,0-6.857,6.855H1.5l2.964,2.963.053.107L7.6,11.355H5.31a5.358,5.358,0,1,1,1.57,3.763L5.8,16.2A6.854,6.854,0,1,0,10.643,4.5ZM9.881,8.308v3.808l3.261,1.935.549-.922-2.667-1.584V8.308Z"
            transform="translate(-1.5 -4.5)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-button-cancel':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="13.71"
          viewBox="0 0 20 20"
        >
          <path
            id="Icon_material-cancel"
            data-name="Icon material-cancel"
            d="M13,3A10,10,0,1,0,23,13,9.991,9.991,0,0,0,13,3Zm5,13.59L16.59,18,13,14.41,9.41,18,8,16.59,11.59,13,8,9.41,9.41,8,13,11.59,16.59,8,18,9.41,14.41,13Z"
            transform="translate(-3 -3)"
            fill="#274463"
          />
        </svg>
      );
    case 'Icon-filter':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="9"
          viewBox="0 0 9 9"
        >
          <path
            id="Icon-filter"
            d="M8.578,0H.422a.422.422,0,0,0-.3.72L3.375,3.972V7.594a.422.422,0,0,0,.18.346l1.406.984a.422.422,0,0,0,.664-.346V3.972L8.876.72A.422.422,0,0,0,8.578,0Z"
            transform="translate(0)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-filter-list':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.75"
          height="6.5"
          viewBox="0 0 9.75 6.5"
        >
          <path
            id="Icon-filter-list"
            d="M8.292,15.5h2.167V14.417H8.292ZM4.5,9v1.083h9.75V9Zm1.625,3.792h6.5V11.708h-6.5Z"
            transform="translate(-4.5 -9)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-search':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 18 18"
        >
          <path
            id="Icon_material-search"
            data-name="Icon material-search"
            d="M17.364,15.821h-.813l-.288-.278a6.7,6.7,0,1,0-.72.72l.278.288v.813L20.967,22.5,22.5,20.967Zm-6.175,0a4.631,4.631,0,1,1,4.631-4.631A4.625,4.625,0,0,1,11.19,15.821Z"
            transform="translate(-4.5 -4.5)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-comment-dots':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          id="Icon_comment-dots"
          data-name="Add New"
          width="29.357"
          height="22.357"
          viewBox="0 0 22.375 22.357"
        >
          {/* <path id="Bg" d="M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z" fill="#5797ff"/>
          <g id="Plus_Icon" data-name="Plus Icon" transform="translate(4.998 4.845)">
            <path id="Fill_26" data-name="Fill 26" d="M11.082,5.155H7.01V1A.98.98,0,1,0,5.051,1V5.155H.98a1,1,0,0,0,0,2H5.051V11.31a.98.98,0,1,0,1.959,0V7.155h4.072a1,1,0,0,0,0-2" fill="#fff"/>
          </g> */}
          <path
            id="Icon_comment-dots"
            data-name="Icon comment-dots"
            d="M11.5,2.25C5.148,2.25,0,6.432,0,11.594a8.293,8.293,0,0,0,2.561,5.871A11.428,11.428,0,0,1,.1,21.769a.357.357,0,0,0-.067.391.352.352,0,0,0,.328.216,10.273,10.273,0,0,0,6.316-2.309,13.7,13.7,0,0,0,4.825.871c6.352,0,11.5-4.182,11.5-9.344S17.852,2.25,11.5,2.25ZM5.75,13.031a1.438,1.438,0,1,1,1.437-1.437A1.436,1.436,0,0,1,5.75,13.031Zm5.75,0a1.438,1.438,0,1,1,1.437-1.437A1.436,1.436,0,0,1,11.5,13.031Zm5.75,0a1.438,1.438,0,1,1,1.438-1.437A1.436,1.436,0,0,1,17.25,13.031Z"
            transform="translate(32.6 -1.17)"
            fill="#b5b5b5"
          />
          {/* */}
        </svg>
      );
    case 'Icon-trash':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.5"
          height="16.333"
          viewBox="0 0 18.5 20.333"
        >
          <g
            id="Icon_feather-trash-2"
            data-name="Icon feather-trash-2"
            transform="translate(-3.5 -2)"
          >
            <path
              id="Path_479"
              data-name="Path 479"
              d="M4.5,9H21"
              transform="translate(0 -2.333)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_480"
              data-name="Path 480"
              d="M20.333,6.667V19.5A1.833,1.833,0,0,1,18.5,21.333H9.333A1.833,1.833,0,0,1,7.5,19.5V6.667m2.75,0V4.833A1.833,1.833,0,0,1,12.083,3H15.75a1.833,1.833,0,0,1,1.833,1.833V6.667"
              transform="translate(-1.167 0)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_481"
              data-name="Path 481"
              d="M15,16.5V22"
              transform="translate(-4.083 -5.25)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_482"
              data-name="Path 482"
              d="M21,16.5V22"
              transform="translate(-6.417 -5.25)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      );
    case 'Icon_feather-edit-2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17.94"
          height="15.939"
          viewBox="0 0 17.94 17.939"
        >
          <path
            id="Icon_feather-edit-2"
            data-name="Icon feather-edit-2"
            d="M14.909,3.915a2.246,2.246,0,1,1,3.176,3.176L7.367,17.809,3,19l1.191-4.367Z"
            transform="translate(-2 -2.06)"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      );
    case 'Icon_material-assignment-turned-in':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16.525"
          height="15.362"
          viewBox="0 0 16.525 18.362"
        >
          <path
            id="Icon_material-assignment-turned-in"
            data-name="Icon material-assignment-turned-in"
            d="M19.189,3.336H15.352a2.743,2.743,0,0,0-5.178,0H6.336A1.842,1.842,0,0,0,4.5,5.172V18.025a1.842,1.842,0,0,0,1.836,1.836H19.189a1.842,1.842,0,0,0,1.836-1.836V5.172A1.842,1.842,0,0,0,19.189,3.336Zm-6.427,0a.918.918,0,1,1-.918.918A.921.921,0,0,1,12.763,3.336ZM10.927,16.189,7.254,12.517l1.294-1.294,2.378,2.369,6.05-6.05,1.294,1.3Z"
            transform="translate(-4.5 -1.5)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon_awesome-check-circle':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 20 20"
        >
          <path
            id="Icon_awesome-check-circle"
            data-name="Icon awesome-check-circle"
            d="M20.563,10.563a10,10,0,1,1-10-10A10,10,0,0,1,20.563,10.563ZM9.406,15.857l7.419-7.419a.645.645,0,0,0,0-.912l-.912-.912a.645.645,0,0,0-.912,0L8.95,12.664,6.125,9.839a.645.645,0,0,0-.912,0l-.912.912a.645.645,0,0,0,0,.912l4.194,4.194a.645.645,0,0,0,.912,0Z"
            transform="translate(-0.563 -0.563)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-view':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.667"
          height="13.045"
          viewBox="0 0 18.667 13.045"
        >
          <g
            id="Icon_feather-eye"
            data-name="Icon feather-eye"
            transform="translate(-1 -6.5)"
          >
            <path
              id="Path_487"
              data-name="Path 487"
              d="M1.5,12.023S4.712,6,10.333,6s8.833,6.023,8.833,6.023-3.212,6.023-8.833,6.023S1.5,12.023,1.5,12.023Z"
              transform="translate(0 1)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_488"
              data-name="Path 488"
              d="M21.887,16.534c0,1.676-1.878,3.034-4.194,3.034S13.5,18.209,13.5,16.534,15.378,13.5,17.694,13.5,21.887,14.858,21.887,16.534Z"
              transform="translate(-7.485 -3.288)"
              fill="none"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </svg>
      );

    case 'Icon-outline-add-circle1':
      return (
        <svg
          id="outline_Add"
          data-name="Outline Add"
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="4 2 24 30"
        >
          <defs>
            <style />
          </defs>
          <title />
          <g data-name="Layer 2" id="Layer_2">
            <path
              fill="#fff"
              d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"
            />
            <path
              fill="#fff"
              d="M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z"
            />
            <path fill="#fff" d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z" />
          </g>
        </svg>
      );
    case 'Icon-outline-add-circle':
      return (
        <svg
          id="outline_Add"
          data-name="Outline Add"
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 32 32"
        >
          <defs>
            <style />
          </defs>
          <title />
          <g data-name="Layer 2" id="Layer_2">
            <path
              fill="#fff"
              d="M16,29A13,13,0,1,1,29,16,13,13,0,0,1,16,29ZM16,5A11,11,0,1,0,27,16,11,11,0,0,0,16,5Z"
            />
            <path
              fill="#fff"
              d="M16,23a1,1,0,0,1-1-1V10a1,1,0,0,1,2,0V22A1,1,0,0,1,16,23Z"
            />
            <path fill="#fff" d="M22,17H10a1,1,0,0,1,0-2H22a1,1,0,0,1,0,2Z" />
          </g>
        </svg>
      );

    case 'Icon-outline-edit':
      return (
        <svg
          className="feather feather-edit"
          fill="none"
          height="18"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          viewBox="0 0 30 30"
          width="18"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
      );

    case 'Icon-addCircle':
      return (
        <svg
          id="Add_New"
          data-name="Add New"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 22 22"
        >
          <path
            id="Bg"
            d="M11,0A11,11,0,1,1,0,11,11,11,0,0,1,11,0Z"
            fill="#5797ff"
          />
          <g
            id="Plus_Icon"
            data-name="Plus Icon"
            transform="translate(4.998 4.845)"
          >
            <path
              id="Fill_26"
              data-name="Fill 26"
              d="M11.082,5.155H7.01V1A.98.98,0,1,0,5.051,1V5.155H.98a1,1,0,0,0,0,2H5.051V11.31a.98.98,0,1,0,1.959,0V7.155h4.072a1,1,0,0,0,0-2"
              fill="#fff"
            />
          </g>
        </svg>
      );
    case 'Icon-add':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M0 0h24v24H0V0z" fill="none" />
          <path
            id="Icon_add_item"
            data-name="Icon add-item"
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
          />
        </svg>
      );
    case 'Icon-comment':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="20.75"
          viewBox="0 0 18 15.75"
        >
          <path
            id="Icon_comment-dots"
            data-name="Icon comment-dots"
            d="M9,2.25c-4.971,0-9,3.273-9,7.312a6.49,6.49,0,0,0,2,4.595A8.944,8.944,0,0,1,.077,17.525a.279.279,0,0,0-.053.306A.275.275,0,0,0,.281,18a8.04,8.04,0,0,0,4.943-1.807A10.722,10.722,0,0,0,9,16.875c4.971,0,9-3.273,9-7.313S13.971,2.25,9,2.25ZM4.5,10.687A1.125,1.125,0,1,1,5.625,9.562,1.124,1.124,0,0,1,4.5,10.687Zm4.5,0a1.125,1.125,0,1,1,1.125-1.125A1.124,1.124,0,0,1,9,10.687Zm4.5,0a1.125,1.125,0,1,1,1.125-1.125A1.124,1.124,0,0,1,13.5,10.687Z"
            transform="translate(0 -2.25)"
            fill="#274463"
          />
        </svg>
      );
    case 'Icon-comment-grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="20.75"
          viewBox="0 0 18 15.75"
        >
          <path
            id="Icon_comment-dots"
            data-name="Icon comment-dots"
            d="M9,2.25c-4.971,0-9,3.273-9,7.312a6.49,6.49,0,0,0,2,4.595A8.944,8.944,0,0,1,.077,17.525a.279.279,0,0,0-.053.306A.275.275,0,0,0,.281,18a8.04,8.04,0,0,0,4.943-1.807A10.722,10.722,0,0,0,9,16.875c4.971,0,9-3.273,9-7.313S13.971,2.25,9,2.25ZM4.5,10.687A1.125,1.125,0,1,1,5.625,9.562,1.124,1.124,0,0,1,4.5,10.687Zm4.5,0a1.125,1.125,0,1,1,1.125-1.125A1.124,1.124,0,0,1,9,10.687Zm4.5,0a1.125,1.125,0,1,1,1.125-1.125A1.124,1.124,0,0,1,13.5,10.687Z"
            transform="translate(0 -2.25)"
            fill="#b5b5b5"
          />
        </svg>
      );
    case 'Icon-arrow':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="11.81"
          height="6.75"
          viewBox="0 0 11.81 6.75"
        >
          <path
            id="Icon-arrow-down1"
            d="M12.095,15.962l4.466-4.467a.841.841,0,0,1,1.192,0,.851.851,0,0,1,0,1.2l-5.06,5.061a.843.843,0,0,1-1.164.025L6.434,12.693a.844.844,0,0,1,1.192-1.2Z"
            transform="translate(-6.188 -11.246)"
            fill="#274463"
          />
        </svg>
      );
    case 'Icon-delete':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          viewBox="0 0 17 21.857"
        >
          <path
            id="Icon_-delete"
            data-name="Icon -delete"
            d="M8.714,23.929a2.436,2.436,0,0,0,2.429,2.429h9.714a2.436,2.436,0,0,0,2.429-2.429V9.357H8.714ZM24.5,5.714H20.25L19.036,4.5H12.964L11.75,5.714H7.5V8.143h17Z"
            transform="translate(-7.5 -4.5)"
            fill="#274463"
          />
        </svg>
      );

    case 'Icon-go-to-check':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23.918"
          height="16.743"
          viewBox="0 0 23.918 16.743"
        >
          <path
            d="M22.722,2.25H1.2A1.2,1.2,0,0,0,0,3.446V17.8a1.2,1.2,0,0,0,1.2,1.2H22.722a1.2,1.2,0,0,0,1.2-1.2V3.446A1.2,1.2,0,0,0,22.722,2.25ZM6.577,13.308v.6a.3.3,0,0,1-.3.3h-.6a.3.3,0,0,1-.3-.3V13.3a2.14,2.14,0,0,1-1.172-.424.3.3,0,0,1-.021-.454L4.627,12a.307.307,0,0,1,.379-.027.9.9,0,0,0,.479.139H6.535a.47.47,0,0,0,.441-.493.488.488,0,0,0-.328-.476l-1.682-.5a1.691,1.691,0,0,1-1.18-1.622A1.664,1.664,0,0,1,5.381,7.337v-.6a.3.3,0,0,1,.3-.3h.6a.3.3,0,0,1,.3.3v.609a2.137,2.137,0,0,1,1.172.424.3.3,0,0,1,.021.454l-.439.419a.307.307,0,0,1-.379.027.9.9,0,0,0-.479-.139H5.423a.47.47,0,0,0-.441.493A.488.488,0,0,0,5.31,9.5l1.682.5a1.691,1.691,0,0,1,1.18,1.622A1.664,1.664,0,0,1,6.577,13.308Zm8.969-.593a.3.3,0,0,1-.3.3H11.062a.3.3,0,0,1-.3-.3v-.6a.3.3,0,0,1,.3-.3h4.186a.3.3,0,0,1,.3.3Zm5.98,0a.3.3,0,0,1-.3.3h-2.99a.3.3,0,0,1-.3-.3v-.6a.3.3,0,0,1,.3-.3h2.99a.3.3,0,0,1,.3.3Zm0-3.588a.3.3,0,0,1-.3.3H11.062a.3.3,0,0,1-.3-.3v-.6a.3.3,0,0,1,.3-.3H21.227a.3.3,0,0,1,.3.3Z"
            transform="translate(0 -2.25)"
            fill="#fff"
          />
        </svg>
      );

    case 'Icon-delete-white':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="-7 0 25 25"
        >
          <path
            id="Icon_-delete"
            data-name="Icon -delete"
            d="M8.714,23.929a2.436,2.436,0,0,0,2.429,2.429h9.714a2.436,2.436,0,0,0,2.429-2.429V9.357H8.714ZM24.5,5.714H20.25L19.036,4.5H12.964L11.75,5.714H7.5V8.143h17Z"
            transform="translate(-7.5 -4.5)"
            fill="#f4f4f4"
          />
        </svg>
      );
    case 'Icon_date-range':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="15.556"
          viewBox="0 0 14 15.556"
        >
          <path
            id="Icon_date-range"
            data-name="Icon date-range"
            d="M10.917,10H7.611v1.556H9.167Zm1.361,0H10.722v1.556h1.556Zm3.111,0H13.833v1.556h1.556Zm1.556-5.444h-.778V3H14.611V4.556H8.389V3H6.833V4.556H6.056A1.548,1.548,0,0,0,4.508,6.111L4.5,17a1.555,1.555,0,0,0,1.556,1.556H16.944A1.56,1.56,0,0,0,18.5,17V6.111A1.56,1.56,0,0,0,16.944,4.556Zm0,12.444H6.056V8.444H16.944Z"
            transform="translate(-4.5 -3)"
            fill="#545955"
          />
        </svg>
      );
    case 'Icon_add':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
        >
          <path
            id="Icon_add"
            data-name="Icon add"
            d="M12.9,7.5H11.1v3.6H7.5v1.8h3.6v3.6h1.8V12.9h3.6V11.1H12.9ZM12,3a9,9,0,1,0,9,9A9,9,0,0,0,12,3Zm0,16.2A7.2,7.2,0,1,1,19.2,12,7.21,7.21,0,0,1,12,19.2Z"
            transform="translate(-3 -3)"
            fill="#fff"
          />
        </svg>
      );
    case 'Icon-Help-Menu':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="23"
          viewBox="8 4 23 27"
          className="svg-fill"
        >
          <g id="icon-help" transform="translate(-1107 -20)">
            <g
              id="icon-help-2"
              data-name="icon-help"
              transform="translate(-7 -1)"
            >
              <path
                id="Path_7"
                data-name="Path 7"
                d="M15.875,5.058a10.813,10.813,0,1,1-7.65,3.167,10.746,10.746,0,0,1,7.65-3.167m0-1.683a12.5,12.5,0,1,0,12.5,12.5,12.5,12.5,0,0,0-12.5-12.5Z"
                transform="translate(1114.625 21.625)"
              />
              <path
                id="Path_8"
                data-name="Path 8"
                d="M17.493,11.25c2.314,0,3.907,1.313,3.907,3.2a3.1,3.1,0,0,1-1.734,2.8c-1.074.638-1.438,1.1-1.438,1.913v.5H16.086l-.019-.543a2.642,2.642,0,0,1,1.457-2.778c1.043-.638,1.481-1.042,1.481-1.824a1.508,1.508,0,0,0-1.66-1.357,1.576,1.576,0,0,0-1.654,1.553H13.5C13.543,12.683,15.012,11.25,17.493,11.25ZM15.87,22.07a1.324,1.324,0,1,1,1.321,1.3A1.306,1.306,0,0,1,15.87,22.07Z"
                transform="translate(1113.5 19.75)"
              />
            </g>
          </g>
        </svg>
      );
      break;
    case 'polygon5':
      return (
        <svg
          width="6"
          height="8"
          viewBox="0 0 6 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 4L0 7.4641L0 0.535898L6 4Z" fill="#FF8700" />
        </svg>
      );
    default:
    //        null;
  }
}
